<icc-list searchable="true" (select)="selectColor($event)" [selected]="colorId" [items]="colors" [itemTemplate]="'itemColor'"></icc-list>



